import {Component} from '@angular/core';

@Component({
    selector: 'app-cars-archive',
    templateUrl: './cars-archive.component.html',
    styleUrl: './cars-archive.component.scss'
})
export class CarsArchiveComponent {

}
